import React from 'react';
import Button from './Button';
import Icon from '../AppIcon';
import { cn } from '../../utils/cn';

const ConfirmDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'default',
  isLoading = false
}) => {
  if (!isOpen) return null;

  const variantClasses = {
    default: 'border-border',
    destructive: 'border-error/20',
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleConfirm = async () => {
    if (onConfirm) {
      await onConfirm();
    }
  };

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      onClick={handleBackdropClick}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" aria-hidden="true" />

      {/* Dialog */}
      <div
        className={cn(
          'relative bg-card border rounded-lg shadow-xl',
          'w-full max-w-md mx-4 p-6',
          'transition-all duration-200',
          'animate-in fade-in-0 zoom-in-95',
          variantClasses[variant]
        )}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
      >
        {/* Icon */}
        <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 rounded-full bg-primary/10">
          <Icon 
            name={variant === 'destructive' ? 'AlertTriangle' : 'HelpCircle'} 
            size={24} 
            color="var(--color-primary)"
          />
        </div>

        {/* Title */}
        <h3 id="dialog-title" className="text-xl font-semibold text-foreground text-center mb-2">
          {title}
        </h3>

        {/* Message */}
        <p id="dialog-description" className="text-sm text-muted-foreground text-center mb-6">
          {message}
        </p>

        {/* Actions */}
        <div className="flex items-center gap-3">
          {cancelLabel && (
            <Button
              variant="outline"
              onClick={onClose}
              disabled={isLoading}
              className="flex-1"
            >
              {cancelLabel}
            </Button>
          )}
          <Button
            variant={variant === 'destructive' ? 'danger' : 'default'}
            onClick={handleConfirm}
            disabled={isLoading}
            loading={isLoading}
            className={cancelLabel ? "flex-1" : "w-full"}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;

